/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CarrierType } from '../model'
// @ts-ignore
import type { CreateInternalWorkInstructionCommand } from '../model'
// @ts-ignore
import type { CreateServiceWorkInstructionCommand } from '../model'
// @ts-ignore
import type { FinishWorkInstructionJobCommand } from '../model'
// @ts-ignore
import type { RailcarTrackPositionDto } from '../model'
// @ts-ignore
import type { SetWorkInstructionPriorityCommand } from '../model'
// @ts-ignore
import type { StartOrResumeWorkInstructionsCommand } from '../model'
// @ts-ignore
import type { StopWorkInstructionsCommand } from '../model'
// @ts-ignore
import type { WorkInstructionControlRoomDto } from '../model'
// @ts-ignore
import type { WorkInstructionDto } from '../model'
// @ts-ignore
import type { WorkInstructionJobDto } from '../model'
// @ts-ignore
import type { WorkInstructionTotalNumbersDto } from '../model'
/**
 * WorkInstructionsApi - axios parameter creator
 */
export const WorkInstructionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateServiceWorkInstructionCommand} [createServiceWorkInstructionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createServiceWorkInstructionCommand?: CreateServiceWorkInstructionCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/createServiceWorkInstruction`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createServiceWorkInstructionCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateInternalWorkInstructionCommand} [createInternalWorkInstructionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInternalWorkInstruction: async (
      createInternalWorkInstructionCommand?: CreateInternalWorkInstructionCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/createInternalWorkInstruction`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createInternalWorkInstructionCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {FinishWorkInstructionJobCommand} [finishWorkInstructionJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finishWorkInstructionJob: async (
      finishWorkInstructionJobCommand?: FinishWorkInstructionJobCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/finishWorkInstructionJob`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        finishWorkInstructionJobCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {number} [equipmentId]
     * @param {number} [workQueueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      carrierVisitId?: number,
      equipmentId?: number,
      workQueueId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      if (equipmentId !== undefined) {
        localVarQueryParameter['EquipmentId'] = equipmentId
      }

      if (workQueueId !== undefined) {
        localVarQueryParameter['WorkQueueId'] = workQueueId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGeneralCargoCompletedAmountById: async (
      id?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/getGeneralCargoCompletedAmountById`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (id !== undefined) {
        localVarQueryParameter['Id'] = id
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalNumbers: async (
      query?: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/getTotalNumbers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (query !== undefined) {
        for (const [key, value] of Object.entries(query)) {
          localVarQueryParameter[key] = value
        }
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInstructionByExternalOrderId: async (
      id?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/getWorkInstructionByExternalOrderId`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (id !== undefined) {
        localVarQueryParameter['Id'] = id
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInstructionsByIds: async (
      ids?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/getWorkInstructionsByIds`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (ids) {
        localVarQueryParameter['Ids'] = ids
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<number>} [visitIds]
     * @param {Array<number>} [workInstructionIds]
     * @param {CarrierType} [carrierVisitType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInstructionsForControlRoom: async (
      visitIds?: Array<number>,
      workInstructionIds?: Array<number>,
      carrierVisitType?: CarrierType,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/getWorkInstructionsForControlRoom`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (visitIds) {
        localVarQueryParameter['VisitIds'] = visitIds
      }

      if (workInstructionIds) {
        localVarQueryParameter['WorkInstructionIds'] = workInstructionIds
      }

      if (carrierVisitType !== undefined) {
        localVarQueryParameter['CarrierVisitType'] = carrierVisitType
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInsturctionsAsJobs: async (
      query?: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/getWorkInsturctionsAsJobs`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (query !== undefined) {
        for (const [key, value] of Object.entries(query)) {
          localVarQueryParameter[key] = value
        }
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [railVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    railcarTrackPositionsByRailVisitId: async (
      railVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/RailcarTrackPositionsByRailVisitId`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (railVisitId !== undefined) {
        localVarQueryParameter['RailVisitId'] = railVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {SetWorkInstructionPriorityCommand} [setWorkInstructionPriorityCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPriority: async (
      setWorkInstructionPriorityCommand?: SetWorkInstructionPriorityCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/setPriority`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        setWorkInstructionPriorityCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {StartOrResumeWorkInstructionsCommand} [startOrResumeWorkInstructionsCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start: async (
      startOrResumeWorkInstructionsCommand?: StartOrResumeWorkInstructionsCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/start`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        startOrResumeWorkInstructionsCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {StopWorkInstructionsCommand} [stopWorkInstructionsCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stop: async (
      stopWorkInstructionsCommand?: StopWorkInstructionsCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/WorkInstructions/stop`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        stopWorkInstructionsCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * WorkInstructionsApi - functional programming interface
 */
export const WorkInstructionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WorkInstructionsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreateServiceWorkInstructionCommand} [createServiceWorkInstructionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createServiceWorkInstructionCommand?: CreateServiceWorkInstructionCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createServiceWorkInstructionCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateInternalWorkInstructionCommand} [createInternalWorkInstructionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createInternalWorkInstruction(
      createInternalWorkInstructionCommand?: CreateInternalWorkInstructionCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createInternalWorkInstruction(
        createInternalWorkInstructionCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.createInternalWorkInstruction']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {FinishWorkInstructionJobCommand} [finishWorkInstructionJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async finishWorkInstructionJob(
      finishWorkInstructionJobCommand?: FinishWorkInstructionJobCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.finishWorkInstructionJob(
        finishWorkInstructionJobCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.finishWorkInstructionJob']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {number} [equipmentId]
     * @param {number} [workQueueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      carrierVisitId?: number,
      equipmentId?: number,
      workQueueId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkInstructionDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(
        carrierVisitId,
        equipmentId,
        workQueueId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGeneralCargoCompletedAmountById(
      id?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getGeneralCargoCompletedAmountById(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.getGeneralCargoCompletedAmountById']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTotalNumbers(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<WorkInstructionTotalNumbersDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalNumbers(query, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.getTotalNumbers']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkInstructionByExternalOrderId(
      id?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkInstructionByExternalOrderId(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.getWorkInstructionByExternalOrderId']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkInstructionsByIds(
      ids?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkInstructionDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkInstructionsByIds(
        ids,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.getWorkInstructionsByIds']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<number>} [visitIds]
     * @param {Array<number>} [workInstructionIds]
     * @param {CarrierType} [carrierVisitType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkInstructionsForControlRoom(
      visitIds?: Array<number>,
      workInstructionIds?: Array<number>,
      carrierVisitType?: CarrierType,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<WorkInstructionControlRoomDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkInstructionsForControlRoom(
        visitIds,
        workInstructionIds,
        carrierVisitType,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.getWorkInstructionsForControlRoom']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkInsturctionsAsJobs(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkInstructionJobDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkInsturctionsAsJobs(
        query,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.getWorkInsturctionsAsJobs']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [railVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async railcarTrackPositionsByRailVisitId(
      railVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RailcarTrackPositionDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.railcarTrackPositionsByRailVisitId(
        railVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.railcarTrackPositionsByRailVisitId']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {SetWorkInstructionPriorityCommand} [setWorkInstructionPriorityCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setPriority(
      setWorkInstructionPriorityCommand?: SetWorkInstructionPriorityCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.setPriority(
        setWorkInstructionPriorityCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.setPriority']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {StartOrResumeWorkInstructionsCommand} [startOrResumeWorkInstructionsCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async start(
      startOrResumeWorkInstructionsCommand?: StartOrResumeWorkInstructionsCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.start(
        startOrResumeWorkInstructionsCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.start']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {StopWorkInstructionsCommand} [stopWorkInstructionsCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stop(
      stopWorkInstructionsCommand?: StopWorkInstructionsCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.stop(
        stopWorkInstructionsCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['WorkInstructionsApi.stop']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * WorkInstructionsApi - factory interface
 */
export const WorkInstructionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WorkInstructionsApiFp(configuration)
  return {
    /**
     *
     * @param {CreateServiceWorkInstructionCommand} [createServiceWorkInstructionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createServiceWorkInstructionCommand?: CreateServiceWorkInstructionCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .create(createServiceWorkInstructionCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateInternalWorkInstructionCommand} [createInternalWorkInstructionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInternalWorkInstruction(
      createInternalWorkInstructionCommand?: CreateInternalWorkInstructionCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .createInternalWorkInstruction(createInternalWorkInstructionCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {FinishWorkInstructionJobCommand} [finishWorkInstructionJobCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finishWorkInstructionJob(
      finishWorkInstructionJobCommand?: FinishWorkInstructionJobCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .finishWorkInstructionJob(finishWorkInstructionJobCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {number} [equipmentId]
     * @param {number} [workQueueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      carrierVisitId?: number,
      equipmentId?: number,
      workQueueId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<WorkInstructionDto>> {
      return localVarFp
        .get(carrierVisitId, equipmentId, workQueueId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGeneralCargoCompletedAmountById(
      id?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .getGeneralCargoCompletedAmountById(id, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalNumbers(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<WorkInstructionTotalNumbersDto>> {
      return localVarFp.getTotalNumbers(query, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInstructionByExternalOrderId(
      id?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .getWorkInstructionByExternalOrderId(id, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInstructionsByIds(
      ids?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<WorkInstructionDto>> {
      return localVarFp
        .getWorkInstructionsByIds(ids, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<number>} [visitIds]
     * @param {Array<number>} [workInstructionIds]
     * @param {CarrierType} [carrierVisitType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInstructionsForControlRoom(
      visitIds?: Array<number>,
      workInstructionIds?: Array<number>,
      carrierVisitType?: CarrierType,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<WorkInstructionControlRoomDto>> {
      return localVarFp
        .getWorkInstructionsForControlRoom(visitIds, workInstructionIds, carrierVisitType, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkInsturctionsAsJobs(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<WorkInstructionJobDto>> {
      return localVarFp
        .getWorkInsturctionsAsJobs(query, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [railVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    railcarTrackPositionsByRailVisitId(
      railVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<RailcarTrackPositionDto>> {
      return localVarFp
        .railcarTrackPositionsByRailVisitId(railVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {SetWorkInstructionPriorityCommand} [setWorkInstructionPriorityCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPriority(
      setWorkInstructionPriorityCommand?: SetWorkInstructionPriorityCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .setPriority(setWorkInstructionPriorityCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {StartOrResumeWorkInstructionsCommand} [startOrResumeWorkInstructionsCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    start(
      startOrResumeWorkInstructionsCommand?: StartOrResumeWorkInstructionsCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .start(startOrResumeWorkInstructionsCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {StopWorkInstructionsCommand} [stopWorkInstructionsCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stop(
      stopWorkInstructionsCommand?: StopWorkInstructionsCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .stop(stopWorkInstructionsCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * WorkInstructionsApi - object-oriented interface
 */
export class WorkInstructionsApi extends BaseAPI {
  /**
   *
   * @param {CreateServiceWorkInstructionCommand} [createServiceWorkInstructionCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(
    createServiceWorkInstructionCommand?: CreateServiceWorkInstructionCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .create(createServiceWorkInstructionCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateInternalWorkInstructionCommand} [createInternalWorkInstructionCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createInternalWorkInstruction(
    createInternalWorkInstructionCommand?: CreateInternalWorkInstructionCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .createInternalWorkInstruction(createInternalWorkInstructionCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {FinishWorkInstructionJobCommand} [finishWorkInstructionJobCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public finishWorkInstructionJob(
    finishWorkInstructionJobCommand?: FinishWorkInstructionJobCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .finishWorkInstructionJob(finishWorkInstructionJobCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {number} [equipmentId]
   * @param {number} [workQueueId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(
    carrierVisitId?: number,
    equipmentId?: number,
    workQueueId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .get(carrierVisitId, equipmentId, workQueueId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [id]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getGeneralCargoCompletedAmountById(id?: number, options?: RawAxiosRequestConfig) {
    return WorkInstructionsApiFp(this.configuration)
      .getGeneralCargoCompletedAmountById(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {object} [query]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getTotalNumbers(query?: object, options?: RawAxiosRequestConfig) {
    return WorkInstructionsApiFp(this.configuration)
      .getTotalNumbers(query, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [id]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getWorkInstructionByExternalOrderId(id?: number, options?: RawAxiosRequestConfig) {
    return WorkInstructionsApiFp(this.configuration)
      .getWorkInstructionByExternalOrderId(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<number>} [ids]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getWorkInstructionsByIds(ids?: Array<number>, options?: RawAxiosRequestConfig) {
    return WorkInstructionsApiFp(this.configuration)
      .getWorkInstructionsByIds(ids, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<number>} [visitIds]
   * @param {Array<number>} [workInstructionIds]
   * @param {CarrierType} [carrierVisitType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getWorkInstructionsForControlRoom(
    visitIds?: Array<number>,
    workInstructionIds?: Array<number>,
    carrierVisitType?: CarrierType,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .getWorkInstructionsForControlRoom(visitIds, workInstructionIds, carrierVisitType, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {object} [query]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getWorkInsturctionsAsJobs(query?: object, options?: RawAxiosRequestConfig) {
    return WorkInstructionsApiFp(this.configuration)
      .getWorkInsturctionsAsJobs(query, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [railVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public railcarTrackPositionsByRailVisitId(railVisitId?: number, options?: RawAxiosRequestConfig) {
    return WorkInstructionsApiFp(this.configuration)
      .railcarTrackPositionsByRailVisitId(railVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {SetWorkInstructionPriorityCommand} [setWorkInstructionPriorityCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public setPriority(
    setWorkInstructionPriorityCommand?: SetWorkInstructionPriorityCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .setPriority(setWorkInstructionPriorityCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {StartOrResumeWorkInstructionsCommand} [startOrResumeWorkInstructionsCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public start(
    startOrResumeWorkInstructionsCommand?: StartOrResumeWorkInstructionsCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .start(startOrResumeWorkInstructionsCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {StopWorkInstructionsCommand} [stopWorkInstructionsCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public stop(
    stopWorkInstructionsCommand?: StopWorkInstructionsCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkInstructionsApiFp(this.configuration)
      .stop(stopWorkInstructionsCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
